import { connect } from 'react-redux';
import TinyCustomSettlements from '../views/tiny/TinyCustomSettlements';

function mapStateToProps(state, ownProps) {
  return {
    // 如果需要 Redux state，可以在這裡添加
  };
}

const mapDispatchToProps = (dispatch) => ({
  // 如果需要 dispatch actions，可以在這裡添加
});

const TinyCustomSettlementsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyCustomSettlements);

export default TinyCustomSettlementsContainer;


